import axios from "axios";
import {config} from '../config/client'


const API_URL = config.endpoint + "/question";

const getQuestion = async () => {
    const response = await axios.get(API_URL);
    return response.data;
}

const createQuestion = async (quiz_obj) => {
    await axios.post(API_URL + "/create", quiz_obj)
}

export default {
    getQuestion, createQuestion
}